import React, { useState, useEffect } from "react";

export const svg = `<svg width="24" height="24" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.781 1.76a.3.3 0 0 0-.562 0l-.346.935a.3.3 0 0 1-.178.178l-.935.346a.3.3 0 0 0 0 .562l.935.346a.3.3 0 0 1 .178.178l.346.935a.3.3 0 0 0 .562 0l.346-.935a.3.3 0 0 1 .178-.178l.935-.346a.3.3 0 0 0 0-.562l-.935-.346a.3.3 0 0 1-.178-.178l-.346-.935ZM4.22 3.26a.3.3 0 0 1 .562 0l.481 1.3a.3.3 0 0 0 .178.178l1.3.48a.3.3 0 0 1 0 .563l-1.3.481a.3.3 0 0 0-.178.178l-.48 1.3a.3.3 0 0 1-.563 0l-.481-1.3a.3.3 0 0 0-.178-.178l-1.3-.48a.3.3 0 0 1 0-.563l1.3-.481a.3.3 0 0 0 .178-.178l.48-1.3Zm-.778 7.786a.474.474 0 0 0-.424.68l3.809 7.91c.537 1.477 4.164 1.512 8.101.079 3.937-1.433 6.693-3.791 6.155-5.268L18.916 5.94a.474.474 0 0 0-.762-.248l-1.96 1.624a.396.396 0 0 0-.137.372l.118.693a1.688 1.688 0 0 1-2.664 1.645l-.814-.598.387-1.818a.474.474 0 0 0-.263-.529L10.25 5.883a.474.474 0 0 0-.63.229L8.42 8.68a.474.474 0 0 0 .138.575l1.465 1.144-.239.982a1.688 1.688 0 0 1-3.098.452l-.355-.607a.397.397 0 0 0-.344-.197l-2.546.016Zm10.838 6.887c2.952-1.075 5.2-2.345 5.021-2.837-.179-.492-2.718-.02-5.67 1.055-2.953 1.075-5.201 2.345-5.022 2.837.18.492 2.718.02 5.67-1.055Z" fill="url(#pro-a)"></path><defs><linearGradient id="pro-a" x1="2.064" y1="20.767" x2="21.267" y2="1.682" gradientUnits="userSpaceOnUse"><stop stop-color="#92713C"></stop><stop offset="1" stop-color="#DBB063"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
